import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { toFormikValidationSchema } from "zod-formik-adapter";
import useSignupMutation from "../../../api/mutation/useSignupMutation";
import { isAxiosError } from "axios";
import ErrorMessage from "@/components/common/ErrorMessage";
import { authSignUpSchema } from "@backend/src/schemas/authSchema";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import InputEmail from "@/components/common/InputEmail";
import { toast } from "react-toastify";
import Google from "../../../assets/svg/google.svg";
import { baseURL } from "../../../Environment";
import NewLogoTitle from "@/assets/png/NewLogo.png";
import BackgroundImage from "@/components/layout/BackgroundImage";
import InputText from "@/components/common/InputText";
import InputPassword from "@/components/common/inputPassword";
import useCurruntLocationQuary from "@/api/query/useCurruntLocationQuary";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import RecaptchaNotice from "../reCaptchaNoticeNotice";
type Language = "FR" | "EN";
function NewSignup() {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { login } = useAuth();
  const navigate = useNavigate();
  const labelStyle = "font-medium text-[13px] text-gray-450 ";
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleSignupClick = () => {
    navigate("/signup");
  };

  const signupMutation = useSignupMutation();
  type FormValues = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
    country: string;
    timeZone: string;
    jobTitle: string;
    language: Language;
    privacyPolicy: boolean;
    captchaToken:string
  };

  const formik = useFormik<FormValues>({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      country: "",
      timeZone: "",
      jobTitle: "",
      language: "FR",
      privacyPolicy: true,
      captchaToken: "",
    },
    validationSchema: toFormikValidationSchema(authSignUpSchema),
    onSubmit: async (values, helper) => {
      setIsLoading(true);
      signupMutation.mutate({...values}, {
        onSuccess(data) {
          login();
          toast.success(data.data.message);
        },
        onError(error) {
          if (isAxiosError(error)) {
            setIsLoading(false);
            if (
              error.response?.status === 400 &&
              error.response?.data.errors &&
              Array.isArray(error.response.data.errors)
            ) {
              error.response.data.errors.map(
                (item: { message: string; path: string[] }) => {
                  helper.setFieldError(item.path[0], item.message);
                }
              );
            }
            if (!Array.isArray(error.response?.data.errors)) {
              toast.error(errorKeyFormate(error.response?.data.message + ""));
            }
          }
        },
      });
    },
  });
  console.log(formik.errors);
  
  const locationQuary = useCurruntLocationQuary();
  useEffect(() => {
    // i18n.changeLanguage(
    //   "fr"
    //   // locationQuary.data?.data.data?.country === "CA" ||
    //   //   locationQuary.data?.data.data?.country === "FR"
    //   //   ? "fr"
    //   //   : "en"
    // );
    formik.setFieldValue(
      "language",
      "FR"
      // "language",
      // locationQuary.data?.data.data?.country === "CA" ||
      //   locationQuary.data?.data.data?.country === "FR"
      //   ? "FR"
      //   : "EN"
    );
  }, [locationQuary.data?.data.data]);
  useEffect(() => {
    const setToken = async () => {
      if (!executeRecaptcha) {
        toast.error(errorKeyFormate("Please verify you are not a robot "));
        return;
      }
      const token = await executeRecaptcha("signup");
      formik.setFieldValue("captchaToken", token);
    }
    setToken();
  }, [locationQuary.data?.data.data])
  

  const google = () => {
    if (formik.values.privacyPolicy) {
      window.open(`${baseURL}/api/auth/google`, "_self");
    } else {
      formik.setErrors({
        privacyPolicy: "Please agree to the Terms and Privacy Policy.",
      });
    }
  };

  const checkError = () => {
    if (formik.values.privacyPolicy == false) {
      formik.setErrors({
        privacyPolicy: "Please agree to the Terms and Privacy Policy.",
      });
    }
  };
  // useEffect(() => {
  //   if (!toast.isActive("toast1324") && window.outerWidth < 768 && location.pathname.includes("signup")) {
  //     toast.error(
  //       t(
  //         "ProjectChef is not yet optimized for mobile devices. We recommend using a computer for a better user experience"
  //       ),
  //       {
  //         autoClose: false,
  //         closeOnClick: false,
  //         toastId: "toast1324",
  //       }
  //     );
  //   }
  // }, []);

  return (
    <>
      <div className="flex justify-center flex-row-reverse min-h-screen bg-secondary-950 sm:px-20 items-center -z-0  h-full w-full">
        <div className=" bg-primary-500/20 rounded-br-3xl absolute top-0 rounded-bl-3xl mb-5 h-24 w-full  max-w-xl flex justify-center items-center">
          <img src={NewLogoTitle} className="h-24" />
        </div>
        <BackgroundImage />
        <div className="flex flex-col items-center w-full h-full lg:w-1/2 justify-center overflow-hidden ">
          <div className=" py-8 px-12 w-auto md:w-full h-[46rem] max-w-xl overflow-y-auto bg-white shadow-lg rounded-3xl -z-0">
            <div className="flex gap-2 items-center justify-center w-full h-11 border-2 rounded-lg bg-[#111111]/25 text-white">
              <div
                className={`w-1/2 h-11 rounded-md text-center cursor-pointer flex items-center justify-center ${
                  location.pathname == "/login" ? "bg-[#0D062D]" : ""
                }`}
                onClick={handleLoginClick}
              >
                {t("Login")}
              </div>
              <div
                className={`w-1/2 h-11 rounded-md text-center cursor-pointer flex items-center justify-center ${
                  location.pathname == "/signup" ? "bg-[#0D062D]" : ""
                }`}
                onClick={handleSignupClick}
              >
                {t("Sign up")}
              </div>
            </div>
            <div className="px-4 py-4">
              <h3 className="text-2xl text-center  text-secondary-950">
                {t("Sign up")}
              </h3>
            </div>
            <div className="flex flex-col items-center px-4 gap-4">
              <Button
                type="button"
                variant={"outline"}
                isLoading={isLoading}
                disabled={isLoading}
                onClick={google}
                className="md:w-3/4 w-auto flex h-12 py-3  rounded-3xl border border-[#0D062D] gap-2.5 hover:bg-opacity-80 disabled:bg-opacity-50"
              >
                <img src={Google} />
                <span>{t("Sign up with Google")}</span>
              </Button>
              {formik.errors.privacyPolicy &&
                formik.errors.privacyPolicy !== "Invalid input" && (
                <span className="text-red-500 text-sm ">
                  {formik.errors.privacyPolicy}
                </span>
              )}
            </div>
            <div className="flex items-center py-4">
              <hr className="flex-grow border-[#666666]/25" />
              <div className="px-4 text-gray-400 text-xs">OR</div>
              <hr className="flex-grow border-[#666666]/25" />
            </div>
            <form
              onSubmit={(e) => {
                e.preventDefault(), checkError(), formik.handleSubmit();
              }}
              className="px-0 pb-4 flex flex-col gap-1"
            >
              <div className="flex flex-col sm:flex-row sm:gap-4 justify-between items-center">
                <div className="w-full">
                  <label htmlFor="firstName" className={labelStyle}>
                    {t("First name")}
                  </label>
                  <div className="">
                    <InputText
                      name="firstName"
                      value={formik.values.firstName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  <ErrorMessage className="!text-xs block mt-1">
                    {formik.touched.firstName &&
                      formik.errors.firstName &&
                      t(formik.errors.firstName ?? "")}
                  </ErrorMessage>
                </div>
                <div className="w-full ">
                  <label htmlFor="lastName" className={labelStyle}>
                    {t("Last name")}
                  </label>
                  <div className="mt-1">
                    <InputText
                      name="lastName"
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  <div>
                    <ErrorMessage className="!text-xs block mt-1">
                      {formik.touched.lastName &&
                        t(formik.errors.lastName ?? "")}
                    </ErrorMessage>
                  </div>
                </div>
              </div>
              <div className="w-full mt-1">
                <label htmlFor="email" className={labelStyle}>
                  {t("Email")}
                </label>

                <InputEmail
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <div>
                  <ErrorMessage className="!text-xs block mt-1">
                    {formik.touched.email && formik.errors.email
                      ? t(formik.errors.email)
                      : ""}
                  </ErrorMessage>
                </div>
              </div>
              <div className="flex flex-col md:flex-row items-center gap-4 w-full">
                <div className="w-full mt-1">
                  <label htmlFor="password" className={labelStyle}>
                    {t("Password")}
                  </label>

                  <div className="relative mt-1">
                    <InputPassword
                      name="password"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  <div>
                    <ErrorMessage className="!text-xs block mt-1">
                      {formik.touched.password &&
                        formik.errors.password &&
                        t(formik.errors.password ?? "")}
                    </ErrorMessage>
                  </div>
                </div>
                <div className="w-full">
                  <label
                    htmlFor="showConfirmationPassword"
                    className={labelStyle}
                  >
                    {t("confirm_password")}
                  </label>

                  <div className="relative mt-1">
                    <InputPassword
                      name="confirmPassword"
                      value={formik.values.confirmPassword}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  <div>
                    <ErrorMessage className="!text-xs block mt-1">
                      {formik.touched.confirmPassword &&
                        formik.errors.confirmPassword &&
                        t(formik.errors.confirmPassword ?? "")}
                    </ErrorMessage>
                  </div>
                </div>
              </div>
              <div className="flex gap-2 items-center justify-center mb-1 p-1">
                <div className="text-sm text-center">
                  {t("By proceeding, you agree to the")} <br />
                  <a
                    className="text-primary-500 text-xs"
                    target="_blank"
                    href="https://projectchef.io/term-and-condition/"
                  >
                    {" "}
                    {t("Terms of Service")}{" "}
                  </a>
                  {t("and")}{" "}
                  <a
                    target="_blank"
                    className="text-primary-500 text-xs"
                    href="https://projectchef.io/privacy-policy/"
                  >
                    {t("Privacy Policy.")}
                  </a>
                </div>
              </div>
              <div className="flex  items-center  mt-1">
                <Button
                  type="submit"
                  variant={"primary"}
                  isLoading={isLoading}
                  disabled={isLoading}
                  className="w-full py-2.5 rounded-md hover:bg-opacity-80 disabled:bg-opacity-50"
                >
                  {t("Sign up")}
                </Button>
              </div>
              <div className="mt-2 text-sm text-grey-600 m-auto">
                {t("Already have an account?")}{" "}
                <NavLink className="font-bold underline" to="/login">
                  {t("Login here")}
                </NavLink>
              </div>
          <RecaptchaNotice/>
            </form>
          </div>
        </div>
        {/* {isMobailView && (
          <div className="w-full">
            <div className=" bg-primary-500/20 rounded-br-3xl absolute top-0 rounded-bl-3xl mb-5 h-24 w-full lg:w-2/5 flex justify-center items-center">
              <img src={NewLogoTitle} className="h-24" />
            </div>
            <div className="font-bold text-base text-white text-center my-2 p-3">
              {t("mobilError")}
            </div>
          </div>
        )} */}
        {/* <div className="lg:flex flex-col items-center justify-center lg:w-1/2 hidden gap-6 ">
          <div className=" bg-primary-500/20 rounded-br-3xl absolute top-0 rounded-bl-3xl mb-5 h-24 w-2/5 flex justify-center items-center">
            <img src={NewLogoTitle} className="h-24" />
          </div>
          <div className="flex gap-3 w-full justify-between">
            <div className="text-center">
              <span className="font-bold text-xl text-white contents">
                {t("Discover more advanced features on")}{" "}
                <span className="text-primary-500">ProjectChef</span>
                {t(
                  ", that enable you to achieve your goals efficiently and collaboratively"
                )}
              </span>
            </div>
          </div>
          <div className="flex gap-3 w-full justify-between">
            <div className="mt-1">
              <img src={checkMark} alt="" className="min-w-5 w-5" />
            </div>
            <div className="">
              <div className="font-bold text-xl text-white">
                {t("Dynamic Gantt Chart")}
              </div>
              <div className="text-gray-500">
                {t("Dynamic Gantt Chart Description")}
              </div>
            </div>
          </div>
          <div className="flex gap-3 w-full justify-between">
            <div className="mt-1">
              <img src={checkMark} alt="" className="min-w-5 w-5" />
            </div>
            <div className="">
              <div className="font-bold text-xl text-white">
                {t("Customizable Kanban Board")}
              </div>
              <div className="text-gray-500">
                {t("Customizable Kanban Board Description")}
              </div>
            </div>
          </div>
          <div className="flex gap-3 w-full justify-between">
            <div className="mt-1">
              <img src={checkMark} alt="" className="min-w-5 w-5" />
            </div>
            <div className="">
              <div className="font-bold text-xl text-white">
                {t("Centralized Task Management")}
              </div>
              <div className="text-gray-500">
                {t("Centralized Task Management Description")}
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}

export default NewSignup;
